<template>
  <div class="contact_us">
    <div class="con_nav">
      <nav-tab :nav-data="navData" />
    </div>
    <div class="con_center">
      <FaqList />
    </div>
    <div class="con_bottom">
      <layout-bottom />
    </div>
  </div>
</template>

<script>
import NavTab from '@/components/NavTab.vue'
import LayoutBottom from '@/components/LayoutBottom.vue'
import FaqList from '@/components/faq/faqList.vue'
export default {
  components: {
    NavTab,
    FaqList,
    LayoutBottom
  },
  data() {
    return {
      navData: {
        index: 2,
        list: [
          {
            name: 'Hogar',
            link: '/'
          },
          {
            name: 'Sobre nosotros',
            link: '/sobre_nosotros'
          },
          {
            name: 'Preguntas frecuentes',
            link: '/preguntas_frecuentes'
          }
          // {
          //   name: 'HOW IT WORKS',
          //   link: '/how_it_works'
          // },
          // {
          //   name: 'FAQ',
          //   link: '/faq'
          // },
          // {
          //   name: 'CONTACT US',
          //   link: '/contact_us'
          // }
        ]
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px){
  .con_center{
    // padding-top: 60px;
  }
}
@media only screen and (max-width: 767px){
  .con_nav{
    height: 150px;
    background: #fff;
  }
}
</style>
